export default {
  namespaced: true,
  state: {
    scannedCode: "",
  },
  mutations: {
    setScannedCode(state, payload) {
      state.scannedCode = payload;
    },
    clearScannedCode(state) {
      state.scannedCode = "";
    },
  },
  getters: {
    getScannedCode: (state) => {
      return state.scannedCode;
    },
  },
};
